import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import {apiConnector} from "../../services/apiconnector"
import {contactusEndpoint} from "../../services/apis";
import CountryCode from "../../data/countrycode.json"

function ContactUsForm(props) {
  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitSuccessful },
  } = useForm();

  async function submitContactForm(data) {
    // console.log("Data: ",data);
    try
    {
        setLoading(true);
        const {
          firstname,lastname,message,email,phoneNo,countrycode
        } = data;
        const response = await apiConnector("POST",contactusEndpoint.CONTACT_US_API,{
          firstname,lastname,message,email,phoneNo,countrycode
        });
        setLoading(false);
        // console.log("Logging response: ",response);
    }
    catch(e)
    {
        console.log("Error in contact us form: ",e);
        setLoading(false);
    }
  }

  useEffect(() => {
    if (!isSubmitSuccessful) {
      reset({
        email: "",
        firstname: "",
        lastname: "",
        message: "",
        phoneNo: "",
        countrycode:"",
      });
    }
  }, [reset, isSubmitSuccessful]);

  return (
    <form onSubmit={handleSubmit(submitContactForm)}>
    <div className="flex flex-col max-[450px]:w-[100%]">
      <div className="flex gap-5 max-[450px]:flex-col">
        {/* first name */}
        <div className="flex flex-col w-full">
          <label className="text-richblack-50" htmlFor="firstname">First name</label>
          <input
            type="text"
            name="firstname"
            id="firstname"
            placeholder="Enter first name"
            className="bg-richblack-700 px-4 py-2 rounded-lg text-richblack-50 mt-1"
            // register using react form hook
            {...register("firstname",{required:true})}
    
          />
          {
            errors.firstname && (
                <span>Please enter your name</span>
            )
          }
        </div>

          {/* last name */}
        <div className="flex flex-col w-full">
          <label className="text-richblack-50" htmlFor="lastname">Last name</label>
          <input
            type="text"
            name="lastname"
            id="lastname"
            placeholder="Enter last name"
            className="bg-richblack-700 px-4 py-2 rounded-lg mt-1 text-richblack-50"
            // register using react form hook
            {...register("lastname")}
    
          />
        </div>
      </div>

        {/* Email name */}
        <div className="flex flex-col mt-4">
          <label className="text-richblack-50" htmlFor="email">Email Address</label>
          <input
            type="email"
            name="email"
            id="email"
            placeholder="Enter email address"
            className="bg-richblack-700 text-richblack-50 px-4 py-2 rounded-lg mt-1"
            // register using react form hook
            {...register("email",{required:true})}
    
          />
          {
            errors.email && (
                <span>Please enter email address</span>
            )
          }
        </div>

          <div className="flex flex-col gap-2 mt-4">
            <label className="text-richblack-50" htmlFor="phoneNo">Phone Number</label>
            <div className="flex flex-row">
              <div className="flex justify-between gap-x-4">
                <select name="dropdown" className="w-[14%] max-[450px]:w-[40%] bg-richblack-700 text-richblack-50 rounded-lg mt-1" id="dropdown" 
                {...register("countrycode",{required:true})}>
                  {/* drop down */}
                  <option value="">Select</option>
                  {
                    CountryCode.map((element,index)=>{
                      return (
                        <option className="text-richblack-50" key={index} value={element.code}>
                          {
                            element.code
                          } -
                          {" "}
                          {
                            element.country
                          }
                        </option>
                      )
                    })
                  }
                </select>
                {/* marked to note */}
                <input type="text" className=" w-[90%] bg-richblack-700 text-richblack-50 px-4 py-2 rounded-lg mt-1" id="phoneNo" name="phoneNo"  placeholder="Enter phone number" {...register("phoneNo",{required:{value:true, message:"Please enter phone number"},maxLength:{value:10,message:"Invalid phone number"}, minLength:{value: 8, message:"Invalid phone number"}})} />
              </div>
              <div>
                {
                  errors.phoneNo && (
                    <span>
                      {errors.phone.message}
                    </span>
                  )
                }
              </div>
            </div>
          </div>

        {/* message */}
        <div className="mt-5">
          <label className="text-richblack-50" htmlFor="message">
            Message
          </label>
          <textarea name="message" id="message" cols="30"  rows="7"
          placeholder="Enter your message here" 
          className="block w-full bg-richblack-700 text-richblack-50 px-4 py-2 rounded-lg mt-1"
           {...register("message",{required:true})}
          ></textarea>
          {
            errors.message && (
                <span>Enter your message</span>
            )
          }
        </div>

          {/* send message */}
        <button type="submit" className="text-center mt-4 text-[13px] px-6 py-3 rounded-md font-bold 
            bg-yellow-50 text-black
            hover:scale-95 transition-all duration-200">Send Message</button>
      </div>
    </form>
  );
}

export default ContactUsForm;
